import { Autocomplete, Checkbox, TextField } from "@mui/material"
import classes from "./style.module.css"

function ChoiceFilter({
  label,
  options,
  value,
  onChange,
  placeholder,
  getOption,
  getOptionLabel,
  width,
  multiple = true,
  backgroundSelectColor = "#ffff",
  checkboxSide = "left",
  withIcon = false,
  disableClearable = false,
  hideSelectedInInput = false,
}) {
  return (
    <>
      <div>
        <Autocomplete
          className={classes.input}
          multiple={multiple}
          disableCloseOnSelect={!!multiple}
          disableClearable={disableClearable}
          value={value}
          onChange={(e, newValue) => {
            onChange(e, newValue)
          }}
          options={options}
          getOptionLabel={getOptionLabel}
          renderOption={(props, option, { selected }) => {
            return (
              <li
                {...props}
                style={{
                  display: checkboxSide === "right" && "flex",
                  justifyContent: checkboxSide === "right" && "space-between",
                }}
              >
                <Checkbox
                  style={{
                    marginRight: withIcon ? 0 : 8,
                    color: withIcon ? "#404846ff" : "#00a78f",
                    fontSize: 14,
                  }}
                  checked={selected}
                />
                {getOption(option)}
              </li>
            )
          }}
          // isOptionEqualToValue={(option, value) => option === value}
          renderTags={() => null}
          style={{ width }}
          ChipProps={{
            className: classes.customChip,
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={placeholder}
              focused
              inputProps={{
                ...params.inputProps,
                value: hideSelectedInInput ? "" : params.inputProps.value,
              }}
              sx={{
                "& .MuiAutocomplete-inputRoot": {
                  borderRadius: "7px",
                  ":hover": {
                    border: "1px solid #028B7E",
                    background: "#fff",
                  },
                },
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    border: "2px solid #028B7E",
                  },
                },
              }}
            />
          )}
        />
      </div>
    </>
  )
}

export default ChoiceFilter
